import ButtonBase, {ButtonOwnProps} from "@mui/material/Button";
import {darken, lighten, getLuminance, PaletteColor, styled} from '@mui/material/styles';

export type ButtonProps = Omit<ButtonOwnProps, "color"> & {
    color?: "primary" | "secondary" | "error" | "warning" | "info" | "success"
}

const Button = styled(ButtonBase)<ButtonProps>(({color = "secondary", theme}) => {
    const paletteColor = theme.palette[color] as PaletteColor | undefined
    const mainColor = paletteColor?.main ?? theme.palette.primary.main
    const lightColor = paletteColor?.light ?? lighten(theme.palette.primary.main, 0.5)
    const fontColor = paletteColor?.contrastText ?? theme.palette.primary.contrastText

    const disabledMainColor = lighten(mainColor, 0.5)
    const disabledFontColor = getLuminance(fontColor) < 0.5 ? lighten(fontColor, 0.7) : darken(fontColor, 0.1)
    return {
        transition: 'border 0.5s, background-color 0.5s',
        border: '2px solid transparent',
        backgroundColor: mainColor,
        borderRadius: 10,
        padding: '5px 10px',
        color: fontColor,
        fontFamily: 'inherit',
        boxShadow: 'none',
        textTransform: 'none',

        ':hover': {
            backgroundColor: lightColor,
            border: `2px solid ${mainColor}`,
            color: fontColor,
            boxShadow: 'none',
        },

        '.MuiSvgIcon-root': {
            color: fontColor,
        },

        ':disabled, [disabled]': {
            backgroundColor: disabledMainColor,

            '.MuiSvgIcon-root': {
                color: disabledFontColor,
            },
        },

        '.MuiButton-loading': {
            color: 'transparent'
        },

        ':not(.MuiButton-loading)': {
            ':disabled, [disabled]': {
                color: disabledFontColor,
            },
        }
    }
})

export default Button
